import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { useSession } from '../auth/AuthProvider';
import { logout } from '../auth/session';
import { VisiteProvider } from '../features/visite/VisiteGuidee';
import { CommandPalette } from '../search/CommandPalette';

import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

const CLE_REPLI = 'mbg-admin.sidebar-collapsed';

function lirePreference(): boolean {
  try {
    return localStorage.getItem(CLE_REPLI) === '1';
  } catch {
    return false;
  }
}

/** Cadre de tous les écrans connectés : barre latérale, barre du haut, recherche globale, visite guidée. */
export function AppShell() {
  const { user } = useSession();
  const [replie, setReplie] = useState(lirePreference);
  const [recherche, setRecherche] = useState(false);

  useEffect(() => {
    const raccourci = (e: globalThis.KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setRecherche((o) => !o);
      }
    };
    window.addEventListener('keydown', raccourci);
    return () => window.removeEventListener('keydown', raccourci);
  }, []);

  const basculer = () => {
    setReplie((r) => {
      try {
        localStorage.setItem(CLE_REPLI, r ? '0' : '1');
      } catch {
        // Préférence non mémorisée : sans conséquence.
      }
      return !r;
    });
  };

  if (!user) return null;

  return (
    <VisiteProvider superAdmin={user.isSuperAdmin}>
      <div className={replie ? 'shell shell--collapsed' : 'shell'}>
        <Sidebar isSuperAdmin={user.isSuperAdmin} collapsed={replie} onToggle={basculer} />
        <div className="shell__main">
          <TopBar user={user} onSearch={() => setRecherche(true)} onLogout={() => logout()} />
          <main className="shell__content" id="contenu">
            <Outlet />
          </main>
        </div>
        <CommandPalette open={recherche} onOpenChange={setRecherche} isSuperAdmin={user.isSuperAdmin} />
      </div>
    </VisiteProvider>
  );
}
